import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { Modal } from "@/components/common";
import styles from "./AddInvoiceJobClosedCheckModal.module.css";
export const AddInvoiceJobClosedCheckModal = ({ isOpen, onClose, onProceedToInvoice, onUpdateToComplete, isUpdating = false, defaultReason, }) => {
    const [showReasonSection, setShowReasonSection] = useState(false);
    const [reason, setReason] = useState("");
    useEffect(() => {
        if (!isOpen) {
            setShowReasonSection(false);
            setReason("");
        }
        else {
            setReason(defaultReason ?? "");
        }
    }, [isOpen, defaultReason]);
    const handleYes = async () => {
        await onUpdateToComplete();
    };
    const handleNo = () => {
        setShowReasonSection(true);
    };
    const handleProceed = () => {
        onProceedToInvoice(reason.trim());
    };
    const handleBack = () => {
        setShowReasonSection(false);
        setReason("");
    };
    if (!isOpen)
        return null;
    return (_jsx(Modal, { isOpen: isOpen, onClose: onClose, children: _jsxs("div", { className: styles.modalWrapper, children: [_jsx("div", { className: styles.modalHeader, children: _jsx("h2", { className: styles.modalTitle, children: "Is the job closed?" }) }), _jsx("div", { className: styles.modalBody, children: !showReasonSection ? (_jsxs("div", { className: styles.buttonGroup, children: [_jsx("button", { type: "button", className: styles.primaryBtn, onClick: handleYes, disabled: isUpdating, children: isUpdating ? "Updating..." : "Yes - Update to Complete Status" }), _jsx("button", { type: "button", className: styles.secondaryBtn, onClick: handleNo, disabled: isUpdating, children: "No - Describe reason why" })] })) : (_jsxs("div", { className: styles.reasonSection, children: [_jsx("label", { htmlFor: "early-invoice-reason", className: styles.fieldLabel, children: "Reason for early invoice" }), _jsx("textarea", { id: "early-invoice-reason", className: styles.textarea, value: reason, onChange: (e) => setReason(e.target.value), placeholder: "Describe why the invoice is being issued before the job is closed...", rows: 4 })] })) }), _jsx("div", { className: styles.modalFooter, children: !showReasonSection ? (_jsx("button", { type: "button", className: styles.cancelBtn, onClick: onClose, children: "Cancel" })) : (_jsxs(_Fragment, { children: [_jsx("button", { type: "button", className: styles.cancelBtn, onClick: handleBack, children: "Back" }), _jsx("button", { type: "button", className: styles.createBtn, onClick: handleProceed, children: "Proceed to Create Invoice" })] })) })] }) }));
};
